import React from 'react';

export default function MailIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 16.7812C21 17.8923 20.0274 18.75 18.9 18.75H5.1C3.97264 18.75 3 17.8923 3 16.7812V7.21875C3 7.21893 3 7.21857 3 7.21875C3.00032 6.10796 3.97283 5.25 5.1 5.25H18.9C20.0241 5.25 20.9945 6.10281 21 7.20925C21 7.21242 21 7.21558 21 7.21875V16.7812ZM3.76748 7.026C3.86954 6.46567 4.40795 6 5.1 6H18.9C19.5921 6 20.1305 6.4657 20.2325 7.02605L12 12.3503L3.76748 7.026ZM3.75 7.90789L11.7964 13.1118C11.9203 13.192 12.0798 13.192 12.2037 13.1118L20.25 7.90794V16.7812C20.25 17.4233 19.6701 18 18.9 18H5.1C4.32986 18 3.75 17.4233 3.75 16.7812V7.90789Z"
        fill={color}
      />
    </svg>
  );
}
